<template>
  <!-- TODO get rid of this padding handling-->
  <v-container v-style:paddingLeft="$valueByBreakpoint($finPadding.left)" v-style:paddingRight="$valueByBreakpoint($finPadding.right)"
               class="mt-4 mb-6"
               fluid>
    <v-row>
      <v-col cols="12">
        <div class="mt-6">
          <h1>Performance-Analyzer</h1>
        </div>
      </v-col>
      <v-col cols="12 ">
        <p>Hier kannst du die Kursentwicklungen von Indizes, Aktien, ETFs und deiner Portfolios über verschiedene
          Zeiträume vergleichen.</p>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12">
        <fin-big-performance-chart
            ref="chart"
            :chart-options="chartOptions"
            :compare-title="$vuetify.breakpoint.xsOnly ? 'Auswahl' : 'Wähle ein Vergleichsinstrument'"
            class="mt-6"
            compare-initial
            hide-values/>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import FinBigPerformanceChart from "@/components/common/Chart2/PerformanceCharts/BigPerformanceChart"
import {mapGetters} from "vuex"
import {getSeries, selectCompareExtreme, seriesId, updateRebaseButton} from "@/components/common/Chart2/CompareChart"
import {DEFAULT_CHART_OPTIONS} from "@/components/common/Chart2/HighChartInit"

export default {
  name: "FinPerformanceAnalyzer1",
  components: {FinBigPerformanceChart},
  data() {
    return {
      compareSelection: [],
      chartOptions: {
        finCompare: {
          select: async (chart, selected) => {
            const series = await getSeries(this.userId, chart, selected)
            if (!series) {
              return '#ff0000'
            }

            const {color} = await chart.addSeries(series)

            this.$nextTick(() => {
              selectCompareExtreme(chart)
            })
            return color
          },
          selectAll: async (chart, selected) => {
            const series = await Promise.all(selected.map(item => getSeries(this.userId, chart, item)))
            series.forEach(item => chart.addSeries(item))
          },
          unselect: async (chart, selected) => {
            //TODO remove subscription as well
            await chart.get(seriesId(selected.item.id)).remove()
            this.$nextTick(() => {
              selectCompareExtreme(chart)
            })
          },
        },
        tooltip: {
          pointFormat: `<span style="color:{series.color}">\u25CF</span> {series.name}: <b>{point.change}%</b>`
        },
        plotOptions: {
          series: {
            compare: 'percent',
          },
        },
        xAxis: {
          events: {
            afterSetExtremes: function (ev) {
              let chart = this.chart
              if (chart) {
                updateRebaseButton(chart)
              }
            }
          }
        }
      }
    }
  },
  computed: {
    ...mapGetters('auth', ['userId']),
  }
}
</script>

<style scoped>

</style>
